import styled, { css } from 'styled-components';
import { FlexColumn, Header3SemiBold, SmallBody } from '@ubeya/shared-web/components';
import { maxMedia, media } from '@ubeya/shared-web/style';

export const Container = styled(FlexColumn)`
  position: relative;
  overflow: scroll;
  flex: 2;
  height: 100%;
  ${media.tablet`overflow: auto;`}
  padding: 44px 200px;
  ${maxMedia.tablet`
    flex-direction: column;
  `};
  ${maxMedia.mobile`
    padding: 44px 10px;
  `};

  .error-text-wrapper {
    margin-bottom: -5px;
  }

  > :not(style) ~ :not(style) {
    margin-top: 32px;
  }
`;

export const SectionContent = styled.div`
  padding: 12px 0;
  width: 100%;
`;

export const Category = styled(Header3SemiBold)`
  background: ${({ theme }) => theme.colors.grey1};
  letter-spacing: 2.25px;
  color: ${({ theme }) => theme.colors.black};
  padding: 4px 13px;
`;

export const FieldsContainer = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-gap: 24px;
  width: 100%;

  ${media.tablet`
    grid-template-columns: repeat(${({ $count = 2 }) => $count}, minmax(0, 1fr));
    

    > ${Category} {
      grid-column: 1/-1;
    }

    > .span-2 {
      grid-column: span 2;
    }

    > .span-3 {
      grid-column: span 3;
    }

    > .span-4 {
      grid-column: span 4;
    }
  
  `}

  ${({ $shouldBrakeLabels }) =>
    $shouldBrakeLabels &&
    css`
      ${SmallBody} {
        white-space: break-spaces;
      }
    `}
`;

export const TabTitle = styled.h2`
  font-size: 24px;
  font-weight: 600;
`;
